import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { testimonials } from '../data/mock';
import { useLanguage } from '../contexts/LanguageContext';

export const Testimonials = () => {
  const { language, t } = useLanguage();

  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">{t.testimonials.title}</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.testimonials.subtitle}
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-5xl font-bold text-amber-600 mb-2">4.9</div>
            <div className="flex justify-center mb-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <div className="text-gray-600">{t.testimonials.avgRating}</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-amber-600 mb-2">450+</div>
            <div className="text-gray-600">{t.testimonials.happyClients}</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-amber-600 mb-2">100%</div>
            <div className="text-gray-600">{t.testimonials.recommendation}</div>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="hover:shadow-xl transition-shadow border-2">
              <CardContent className="p-8">
                <div className="flex items-start mb-4">
                  <Quote className="w-10 h-10 text-amber-600 opacity-50 flex-shrink-0" />
                </div>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed italic">
                  "{testimonial.text[language]}"
                </p>
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <div className="border-t pt-4">
                  <p className="font-semibold text-gray-900 text-lg">{testimonial.name}</p>
                  <p className="text-gray-600">{testimonial.location}</p>
                  <p className="text-sm text-gray-500 mt-1">{testimonial.date[language]}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-br from-amber-600 to-amber-700 rounded-2xl p-12 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">{t.testimonials.ctaTitle}</h2>
          <p className="text-xl text-amber-100 mb-8 max-w-2xl mx-auto">
            {t.testimonials.ctaSubtitle}
          </p>
          <a
            href="/contato"
            className="inline-block bg-white text-amber-600 hover:bg-gray-100 font-semibold px-8 py-4 rounded-lg transition-colors"
          >
            {t.testimonials.ctaButton}
          </a>
        </div>
      </div>
    </div>
  );
};